import NoAccessBox from './NoAccessBox';

export { NoAccessBox };

export default NoAccessBox;
